import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Select from '../Select';
import Typography from '../Typography';
import Button from '../Button';
import HotkeysPreferences from '../HotkeysPreferences';
import { ButtonEnums } from '../Button';

const UserPreferences = ({
  availableLanguages,
  defaultLanguage,
  currentLanguage,
  disabled = false,
  hotkeyDefinitions,
  hotkeyDefaults,
  onCancel = () => {},
  onSubmit = () => {},
  onReset = () => {},
  hotkeysModule,
}) => {
  const { t } = useTranslation('UserPreferencesModal');
  const [state, setState] = useState({
    isDisabled: disabled,
    hotkeyErrors: {},
    hotkeyDefinitions,
    language: currentLanguage,
  });

  const onSubmitHandler = () => {
    onSubmit(state);
  };

  const onResetHandler = () => {
    setState(state => ({
      ...state,
      language: defaultLanguage,
      hotkeyDefinitions: hotkeyDefaults,
      hotkeyErrors: {},
      isDisabled: disabled,
    }));
    onReset();
  };

  const onCancelHandler = () => {
    setState({ hotkeyDefinitions });
    onCancel();
  };

  const onLanguageChangeHandler = value => {
    setState(state => ({ ...state, language: value }));
  };

  const onHotkeysChangeHandler = (id, definition, errors) => {
    setState(state => ({
      ...state,
      isDisabled: Object.values(errors).every(e => e !== undefined),
      hotkeyErrors: errors,
      hotkeyDefinitions: {
        ...state.hotkeyDefinitions,
        [id]: definition,
      },
    }));
  };

  const Section = ({ title, children }) => (
    <div className="mt-4 mb-8">
      {/* {title && title.notempty (
        <div className="mb-2 border-b-2 border-black">
          <Typography
            variant="inherit"
            color="primaryLight"
            className="flex pb-2 text-[16px] font-semibold !leading-[1.2]"
          >
            {title}
          </Typography>
        </div>
      )} */}
      {children}
    </div>
  );

  return (
    <div>
      <div className="max-h-[260px] overflow-y-auto px-4">
        <Section title="">
          <HotkeysPreferences
            disabled={disabled}
            hotkeyDefinitions={state.hotkeyDefinitions}
            onChange={onHotkeysChangeHandler}
            errors={state.hotkeyErrors}
            hotkeysModule={hotkeysModule}
          />
        </Section>
      </div>

      {/* Button footer always visible */}
      <div className="border-t px-4 py-3">
        <div className="flex flex-row justify-between">
          <Button
            type={ButtonEnums.type.secondary}
            onClick={onResetHandler}
            disabled={disabled}
          >
            {t('Reset to defaults')}
          </Button>
          <div className="flex flex-row">
            <Button
              type={ButtonEnums.type.secondary}
              onClick={onCancelHandler}
            >
              {t('Hủy')}
            </Button>
            <Button
              disabled={state.isDisabled}
              className="ml-2"
              onClick={onSubmitHandler}
            >
              {t('Lưu')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

UserPreferences.propTypes = {
  availableLanguages: PropTypes.array.isRequired,
  defaultLanguage: PropTypes.any.isRequired,
  currentLanguage: PropTypes.any.isRequired,
  disabled: PropTypes.bool,
  hotkeyDefaults: PropTypes.object.isRequired,
  hotkeyDefinitions: PropTypes.object.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
  onReset: PropTypes.func,
  hotkeysModule: PropTypes.shape({
    initialize: PropTypes.func.isRequired,
    pause: PropTypes.func.isRequired,
    unpause: PropTypes.func.isRequired,
    startRecording: PropTypes.func.isRequired,
    record: PropTypes.func.isRequired,
  }).isRequired,
};

export default UserPreferences;
